import React, { useEffect, useState, useCallback } from "react";
import styles from "./container.scss";
import { useLocation, useParams, Route, useHistory } from "react-router";
import { Sidebar } from "../sidebar/sidebar";
import { Map } from "../map/map";
import Modal from "react-modal";
import { Krpano } from "../krpano/krpano";
import { debounce, find } from "lodash";
import { getSearchResults, loadFilters, getToursByLocation } from "../../common/api";
import { activeFiltersState, filtersState } from "../../common/recoil-atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Constants } from "../../common/constants";
import { useLocationChange, useQueryParams } from "../../common/hooks";
import queryString from "query-string";
import { CompanyVideo } from "../companyvideo/companyvideo";

function getActiveFilters(filtersData, queryParams) {
    /** Searches a filterItem with a specific id */
    function searchFilterItem(items, id) {
        for (let item of items) {
            if (item.id == id) {
                return item;
            } else if (item.items) {
                var tmp = searchFilterItem(item.items, id);
                if (tmp) return tmp;
            }
        }
    }

    function addParameter(type) {
        if (!filtersData) return;
        for (let id of (queryParams[type] || "")
            .split(Constants.FilterSplitChar)
            .filter((x) => !!x)) {
            // search filter in base data (coming from API), for the name
            var name = "---";
            if (filtersData) {
                var baseFilter = searchFilterItem(filtersData, id);
                if (baseFilter) name = baseFilter.name;
            }

            result.push({
                name: name,
                id: id,
                type: type,
            });
        }
    }

    if (!filtersData.length) return [];

    var result = [];

    addParameter("province");
    addParameter("city"); // subitem of province
    addParameter("sector");
    addParameter("type");

    if (queryParams.lat && queryParams.lng) {
        result.push({
            name: "Mijn locatie",
            id: 0,
            type: "geolocation",
        });
    }

    return result;
}

function addCheckedProperty(items) {
    for (let item of items) {
        item.checked = false;
        if (item.items) {
            addCheckedProperty(item.items);
        }
    }
}

/** Recursive traverse all filers, and check the ones which are being used in query params */
function traverseAndCheckFilterItems(items, queryParams) {
    for (let item of items) {
        item.checked = false;
        if (queryParams) {
            var param = queryParams[item.type];
            if (param) {
                if (param.indexOf(item.id.toString()) > -1) {
                    item.checked = true;
                }
            }
        }
        if (item.items) {
            traverseAndCheckFilterItems(item.items, queryParams);
        }
    }
}


const Container = ({ children, isEmbed }) => {
    // Router api
    const location = useLocation();
    const params = useParams();
    const history = useHistory();

    // App specific
    const [loading, setLoading] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const [searching, setSearching] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(null); // set null so we can alter content before first search
    const [mapOpen, setMapOpen] = useState(true);
    // Filters
    const setActiveFilters = useSetRecoilState(activeFiltersState);
    const [filtersData, setFiltersData] = useRecoilState(filtersState);
    const [filtersNavOpen, setFiltersNavOpen] = useState(false);

    // Tour specific
    const [tours, setTours] = useState([]);
    const [currentTour, setCurrentTour] = useState(undefined);
    const [vtOnly, setVtOnly] = useState(false);


    // Modal specific
    const [modalOpened, setModalOpened] = useState(false);
    const [videoModalOpened, setVideoModalOpened] = useState(false);

    // Other
    const query = useQueryParams();

    useEffect(() => {
        const fetchFilters = async () => {
            // console.log("fetch filters");
            let result = await loadFilters();
            var data = result.body;

            addCheckedProperty(data);
            traverseAndCheckFilterItems(data, query);
            setFiltersData(data);

            setActiveFilters(getActiveFilters(data, query));
        };

        // showMap();
        fetchFilters();
    }, []);

    useLocationChange(() => {
        if (filtersData) {
            // if filtersdata is loaded yet
            var copy = JSON.parse(JSON.stringify(filtersData));
            traverseAndCheckFilterItems(copy, query);
            setFiltersData(copy);
            setActiveFilters(getActiveFilters(copy, query));
        }

        const fetchTours = async () => {
            // console.log("FETCH TOURS");
            setLoading(true); // show loader
            let result = await getToursByLocation(location);

            if( query.tour ) {
                let tmp = find(result.body, {'slug':query.tour});
                if( tmp ) {
                    setCurrentTour(tmp);
                } else {
                    setCurrentTour(undefined);
                }
            } else {
                setCurrentTour(undefined);
            }
            setTours(result.body);
            setLoading(false);
        };

        if (!params.tour) {
            fetchTours();
        }

        if( query.vtOnly ) {
            setVtOnly(true);
        }

        const openVirtualTour = !!params.tour;
        setModalOpened(openVirtualTour);
        
        const openCompanyvideo = !!params.company;
        setVideoModalOpened(openCompanyvideo);
    });

    const showMap = () => {
        var model = queryString.parse(location.search);

        if (model.showmap && model.showmap == 1) {

            setMapOpen(true);
            delete model.showmap;
            history.push(`/kaart?${queryString.stringify(model)}`);
        }
    }

    const handleCloseModal = () => {
        // Redirect
        window.location.href = "https://www.openbedrijvendag.be/alle-deelnemende-bedrijven/";

        // // depends on the source. Map? just close popup. Homepage? really pagechange
        // if (query.source !== "map") {
        //     window.location.href = "/";
        // } else {
        //     // Get correct query params and apply them
        //     var model = queryString.parse(location.search);
        //     if (model.source) delete model.source;
        //     if (model.tour) delete model.tour;
        //     history.push(`/kaart?${queryString.stringify(model)}`);
        // }
    };

    const handleAfterOpen = (e) => {
        // console.log("Load VR tour data");
    };

    const handleSelectTour = (tour) => (e) => {
        // console.log(e.currentTarget, tour);
        setCurrentTour(tour);
    };

    const handleNavOpen = (e) => {
        setNavOpen(true);
    };

    const handleNavClose = (e) => {
        setNavOpen(false);
    };

    const handleSearchOpen = (e) => {
        setSearchOpen(true);
    };

    const handleSearchClose = (e) => {
        setSearchOpen(false);
    };

    const handleFiltersNavOpen = (e) => {
        setFiltersNavOpen(!filtersNavOpen);
    };

    const handleMapOpen = (e) => {
        setMapOpen(true);
    };

    const handleMapClose = (e) => {
        setMapOpen(false);
    };

    const handleCloseSelectedTour = (e) => {
        setCurrentTour(null);
    };

    const handleSearching = (e) => {
        const noInteract = [
            "Escape",
            "Shift",
            "Enter",
            "CapsLock",
            "Meta",
            "Control",
            "Alt",
            "ArrowLeft",
            "ArrowRight",
            "ArrowDown",
            "ArrowUp",
        ];

        // Only allow normal character input
        if (noInteract.indexOf(e.key) > -1) {
            return;
        }

        setSearching(true); // show loader whenever you are typing
        fetchSearchResults(e.target.value);
    };

    const handleGeoLocation = (e) => {
        navigator.geolocation.getCurrentPosition(gotCurrentLocation);
    }
    const gotCurrentLocation = (position) => {
        let tmp = { ...query, lat: position.coords.latitude, lng: position.coords.longitude };
        history.push(`/kaart?${queryString.stringify(tmp)}`);
    }

    // We have to cache the old function via React.useCallback
    // https://medium.com/@kartikag01/debounce-api-request-in-react-functional-component-664b4971d9dd
    const fetchSearchResults = useCallback(
        debounce(async (query) => {
            if (query.length > 0) {
                let result = await getSearchResults(query);
                setSearchResults(result.body);
            } else {
                setSearchResults(null);
            }
            setSearching(false);
        }, 500),
        []
    );

    return (
        <div className={styles.container}>
            {/* { !isEmbed && (
                <Sidebar
                    onSelectTour={handleSelectTour}
                    onNavOpen={handleNavOpen}
                    onNavClose={handleNavClose}
                    onSearchOpen={handleSearchOpen}
                    onSearchClose={handleSearchClose}
                    onFiltersNavOpen={handleFiltersNavOpen}
                    onMapOpen={handleMapOpen}
                    onMapClose={handleMapClose}
                    onSearching={handleSearching}
                    tours={tours}
                    currentTour={currentTour}
                    navOpen={navOpen}
                    mapOpen={mapOpen}
                    searchOpen={searchOpen}
                    filtersNavOpen={filtersNavOpen}
                    loading={loading}
                    searching={searching}
                    searchResults={searchResults}
                />
            )}
            { !isEmbed && (
                <Map
                    onSelectTour={handleSelectTour}
                    onCloseSelectedTour={handleCloseSelectedTour}
                    onMapClose={handleMapClose}
                    currentTour={currentTour}
                    tours={tours}
                    loading={loading}
                    location={location}
                    centerLocation={[query.lng ?? 3.6911379, query.lat ?? 51.0823113]}
                    showUserLocation={query.lng && query.lat ? [query.lng, query.lat] : false}
                    onGeoLocation={handleGeoLocation}
                />
            )} */}
            <Modal
                style={{
                    overlay: {
                        zIndex: 1000,
                    },
                    content: {
                        top: "0px",
                        right: "0px",
                        bottom: "0px",
                        left: "0px",
                        border: "none",
                        borderRadius: "0",
                        padding: "0",
                        overflow: "hidden",
                    },
                }}
                ariaHideApp={false}
                isOpen={modalOpened}
                onAfterOpen={handleAfterOpen}
                onRequestClose={handleCloseModal}
                shouldCloseOnEsc={false}
            >
                { !isEmbed && !vtOnly && (
                    <button
                        onClick={handleCloseModal}
                        className={[styles.modalClose, styles.modalClose__desktop].join(" ")}
                        style={{ color: "white" }}
                    >
                        <span>{window.tstrings["Ga terug"]}</span>
                        <img src={"/img/logo-white-trans-2023.svg"} />
                    </button>
                )}
                { !isEmbed && !vtOnly && (
                    <button
                        onClick={handleCloseModal}
                        className={[styles.modalClose, styles.modalClose__mobile].join(" ")}
                        style={{ color: "white" }}
                    >
                        <span>{window.tstrings["Sluiten"]}</span>
                        <img src={"/img/icon-pano-close-white.svg"} />
                    </button>
                )}
                    <Krpano isEmbed={isEmbed} vtOnly={vtOnly} />
            </Modal>

            <Modal
                style={{
                    overlay: {
                        zIndex: 1000,
                        background: "transparent"
                    },
                    content: {
                        top: "0px",
                        right: "0px",
                        bottom: "0px",
                        left: "0px",
                        border: "none",
                        borderRadius: "0",
                        padding: "0",
                        overflow: "hidden",
                        background: "rgba(0, 0, 0, 0.8)"
                    },
                }}
                ariaHideApp={false}
                isOpen={videoModalOpened}
                onRequestClose={handleCloseModal}
                shouldCloseOnEsc={false}
            >
                    <button
                        onClick={handleCloseModal}
                        className={styles.modalClose__video}
                        style={{ color: "white" }}
                    >
                        <svg vxmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 14 14">
                            <path d="M8.41,7L14,12.59L12.59,14L7,8.41L1.41,14L0,12.59L5.59,7L0,1.41L1.41,0L7,5.59L12.59,0L14,1.41L8.41,7z"/>
                        </svg>
                    </button>
                    <CompanyVideo />
            </Modal>
        </div>
    );
};

export { Container };
